import {
    sweep,
    undoCommandingBar,
    previousLabel,
    nextLabel,
    closeLabel,
} from './MailCommandingBar.locstring.json';
import { moveTo } from 'owa-locstrings/lib/strings/moveto.locstring.json';
import { stopIgnoring } from 'owa-locstrings/lib/strings/stopignoring.locstring.json';
import { ignore } from 'owa-locstrings/lib/strings/ignore.locstring.json';
import { unpin } from 'owa-locstrings/lib/strings/unpin.locstring.json';
import { snooze } from 'owa-locstrings/lib/strings/snooze.locstring.json';
import { categoryMenuItemMenuText } from 'owa-locstrings/lib/strings/categorymenuitemmenutext.locstring.json';
import { print } from 'owa-locstrings/lib/strings/print.locstring.json';
import { unflag } from 'owa-locstrings/lib/strings/unflag.locstring.json';
import { block } from 'owa-locstrings/lib/strings/block.locstring.json';
import { phishing } from 'owa-locstrings/lib/strings/phishing.locstring.json';
import { notjunk } from 'owa-locstrings/lib/strings/notjunk.locstring.json';
import { junk } from 'owa-locstrings/lib/strings/junk.locstring.json';
import { restoreItem } from 'owa-locstrings/lib/strings/restoreitem.locstring.json';
import { mailEllipsisAriaLabelText } from 'owa-locstrings/lib/strings/mailellipsisarialabeltext.locstring.json';
import { newMailAction, newNoteAction } from '../strings.locstring.json';
import { markAsRead } from 'owa-locstrings/lib/strings/markasread.locstring.json';
import { markAllAsRead } from 'owa-locstrings/lib/strings/markallasread.locstring.json';
import { flag } from 'owa-locstrings/lib/strings/flag.locstring.json';
import { pin } from 'owa-locstrings/lib/strings/pin.locstring.json';
import { archive } from 'owa-locstrings/lib/strings/archive.locstring.json';
import { deleteItem } from 'owa-locstrings/lib/strings/deleteitem.locstring.json';
import { showInImmersiveReader as showInImmersiveReader_1 } from 'owa-locstrings/lib/strings/showinimmersivereader.locstring.json';
import { itemHeaderTranslate } from 'owa-locstrings/lib/strings/itemheadertranslate.locstring.json';
import { createRule } from 'owa-locstrings/lib/strings/createrule.locstring.json';
import { assignPolicyMenuItemName } from 'owa-locstrings/lib/strings/assignpolicymenuitemname.locstring.json';
import { markAsUnread } from 'owa-locstrings/lib/strings/markasunread.locstring.json';
import { itemHeaderForward } from 'owa-locstrings/lib/strings/itemheaderforward.locstring.json';
import { itemHeaderReplyAll } from 'owa-locstrings/lib/strings/itemheaderreplyall.locstring.json';
import { itemHeaderReply } from 'owa-locstrings/lib/strings/itemheaderreply.locstring.json';
import { optOutToggleLabel } from 'owa-locstrings/lib/strings/optouttogglelabel.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47708 */
import * as lazyTriageActions from 'owa-mail-triage-action';
import closeImmersiveReadingPane from 'owa-mail-actions/lib/closeImmersiveReadingPane';
import * as React from 'react';
import * as undoActions from 'owa-mail-undo';
import checkAndCreateNewMessage from 'owa-mail-message-actions/lib/actions/checkAndCreateNewMessage';
import createSnoozeSubMenu from 'owa-mail-datepicker/lib/utils/createSnoozeSubMenu';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import getMailMenuItemShouldDisable from 'owa-mail-filterable-menu-behavior/lib/actions/getMailMenuItemShouldDisable';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isReadingPanePositionBottom } from 'owa-mail-layout/lib/selectors/readingPanePosition';
import { isImmersiveReadingPaneShown } from 'owa-mail-layout/lib/selectors/isImmersiveReadingPaneShown';
import isReplyAllTheDefaultResponse from 'owa-mail-reading-pane-store/lib/utils/isReplyAllTheDefaultResponse';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { classNamesFunction } from 'office-ui-fabric-react/lib/Utilities';
import { CommandBarButton } from 'office-ui-fabric-react/lib/Button';
import { computed } from 'mobx';
import { ControlIcons } from 'owa-control-icons';
import { DisplayOption, FilterableCommandBar, FilterableMenuItem } from 'owa-filterable-menu';
import { getAssignPolicyPropertiesForMailContextMenu } from 'owa-mail-retention-policies';
import { getCategoryMenuPropertiesForCommandBar } from 'owa-mail-category-view';
import { getGroupId } from 'owa-group-utils';
import { getMailMenuItemShouldShowMap, MenuItemType } from 'owa-mail-filterable-menu-behavior';
import { getMenuItemStyles } from 'office-ui-fabric-react/lib/components/ContextualMenu/ContextualMenu.cnstyles';
import { getMoveToPropertiesForCommandBar } from 'owa-mail-movetofolder-view';
import { getTheme, ITheme } from 'office-ui-fabric-react/lib/Styling';
import { Icon } from 'office-ui-fabric-react/lib/components/Icon';
import {
    IMenuItemStyles,
    IContextualMenuItem,
    DirectionalHint,
} from 'office-ui-fabric-react/lib/components/ContextualMenu';
import { isBulkActionInState, BulkActionStateEnum } from 'owa-bulk-action-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import isTranslatorEnabled from 'owa-addins-outlook-translate/lib/isTranslatorEnabled';
import { lazyScheduleRows } from 'owa-mail-triage-action';
import { lazyShowSweepDialog } from 'owa-mail-sweep-view';
import { MailIcons } from 'owa-mail-icons';
import { MailListItemSelectionSource } from 'owa-mail-store';
import { observer } from 'mobx-react';
import { OptOutToggle, createOptOutToggleHandler } from 'owa-client-optout/lib/ClientOptOutItem';
import { lazyResetFocus } from 'owa-mail-focus-manager';
import { selectRowInDirection } from 'owa-mail-actions/lib/mailListSelectionActions';
import { showInImmersiveReader } from 'owa-immersive-reader-store';
import {
    lazyMarkItemsAsReadBasedOnNodeIds,
    lazyMarkAsReadInTable,
    lazyOnNavigateAwayViaUpDown,
} from 'owa-mail-mark-read-actions';
import {
    getIsEverythingSelectedInTable,
    listViewStore,
    TableQueryType,
    TableView,
    MailRowDataPropertyGetter,
    SelectionDirection,
    isItemPartOperation,
    shouldSuppressServerMarkReadOnReplyOrForward,
    isFolderPaused,
} from 'owa-mail-list-store';
import getEmptyFolderText from 'owa-mail-list-store/lib/utils/getEmptyFolderText';
import {
    lazyForwardConversation,
    lazyReplyToConversation,
    lazyForwardItem,
    lazyReplyToItem,
    lazyPrintConversation,
    lazyPrintItem,
    lazyShowConversationInImmersiveReader,
} from 'owa-mail-message-actions';
import { OwaDate } from 'owa-datetime';
import { lazyOpenCompose } from 'owa-mail-compose-actions';
import NewMessageButton from './NewMessageButton';
import { UpNextV2 } from 'owa-upnext-v2';
import {
    default as notesStore,
    lazyCreateNewNote,
    lazyDeleteNote,
    NoteColorButton,
} from 'owa-notes';
import { lazyCreateRuleFromRow } from 'owa-mail-inbox-rules';
import { lazyKeydown } from 'owa-hotkeys';
import { LazyAction, LazyModule } from 'owa-bundling';
import { getUpNextStore } from 'owa-upnext-event-loader/lib/store/store';
import getSnoozeDateOptions from 'owa-mail-datepicker/lib/utils/getSnoozeDateOptions';
import { getStore } from 'owa-mail-list-store/lib/store/Store';

const lazyModule = new LazyModule(() => import('./lazy/lazyCommandBarKeys'));
const lazySetupMailCommandingBarKeys = new LazyAction(
    lazyModule,
    m => m.setupMailCommandingBarKeys
);
const styles = require('./MailCommandingBar.scss');
const classNames = require('classnames');
const getClassNames = classNamesFunction<ITheme, IMenuItemStyles>();

export interface MailCommandingBarProps {
    tableViewId: string;
}

@observer
@lazyKeydown(lazySetupMailCommandingBarKeys.importAndExecute)
export default class MailCommandingBar extends React.Component<MailCommandingBarProps, {}> {
    private shouldShowBehaviorMap;
    constructor(props: MailCommandingBarProps) {
        super(props);
        this.shouldShowBehaviorMap = getMailMenuItemShouldShowMap();
    }

    /**
     * UpNext component is delay rendered and its not guaranteed that there will be an event
     * always to render in this component. When it delay renders with an event, commanding bar has already done
     * calculations to determine how many items can fit, this will sometimes leave no space for UpNext
     * and UpNext shall be cut off. To fix this, we can update the cache key used for this component. Whenever a cacheKey
     * for any commandbar item changes it triggers a remeasure.
     */
    @computed
    get cacheKeyForUpNextItem(): string {
        if (
            !isFeatureEnabled('tri-upNextV2') ||
            !getUpNextStore().scenarios.get('TimePanelAgenda_UpNextCalendarCacheId')
        ) {
            return 'UpNext';
        }
        return 'UpNextUpdated';
    }

    @computed
    get tableView(): TableView {
        return listViewStore.tableViews.get(this.props.tableViewId);
    }

    @computed
    get isItemPartCommandBarOperation(): boolean {
        return isItemPartOperation();
    }

    render() {
        return (
            <FilterableCommandBar
                filterableItems={this.commandingBarItems}
                elipisisAriaLabel={loc(mailEllipsisAriaLabelText)}
            />
        );
    }

    private get commandingBarItems(): any {
        // Items to display in the Display Bar.
        const itemsToDisplay = [
            this.newMessageItem,
            this.newNoteItem,
            this.replyMenuItem,
            this.deleteMenuItem,
            this.restoreMenuItem,
            this.archiveDraftMenuItem,
            this.junkMenuItem,
            this.notJunkMenuItem,
            this.sweepMenuItem,
            this.moveToMenuItem,
            this.categoryMenuItem,
            this.emptyFolderMenuItem,
            this.markAllAsReadMenuItem,
            this.markAsUnreadMenuItem,
            this.markAsReadMenuItem,
            this.scheduleMenuItem,
            this.flagMenuItem,
            this.unflagMenuItem,
            this.pinMenuItem,
            this.unpinMenuItem,
            this.ignoreMenuItem,
            this.stopIgnoringMenuItem,
            this.overflowDivider,
            this.createRuleMenuItem,
            this.printMenuItem,
        ];

        if (isFeatureEnabled('gsx-translator-translateMessage') && isTranslatorEnabled()) {
            itemsToDisplay.push(this.translateMenuItem);
        }

        if (isFeatureEnabled('rp-immersiveReader')) {
            itemsToDisplay.push(this.showInImmersiveReaderMenuItem);
        }

        if (!isConsumer()) {
            itemsToDisplay.push(this.assignPolicyMenuItem);
        }

        itemsToDisplay.push(this.undoMenuItem);
        const isInImmersiveReadingPane = isImmersiveReadingPaneShown();

        if (isFeatureEnabled('fwk-fluentCommandBar')) {
            itemsToDisplay.push(this.pseudoItemForCorrection);
        }

        // Show UpNext only when not in immersive RP
        if (isFeatureEnabled('tri-upNextV2') && !isInImmersiveReadingPane) {
            itemsToDisplay.push(this.upNextMenuItem);
        }

        itemsToDisplay.push(this.optOutMenuItem);

        // Items to display on the right in immersive view.
        // These items depend on the list view selection.
        // We are not doing this using behavior as it ends up rendering the commanding bar when the selection changes.
        // This behavior is handled in this file itself
        if (isInImmersiveReadingPane) {
            itemsToDisplay.push(this.selectPreviousMenuItem);
            itemsToDisplay.push(this.selectNextMenuItem);
            itemsToDisplay.push(this.closeImmersiveReadingPaneMenuItem);
        }

        // Add "Delete" and "Color" commands when in Notes folder, with notes-folder-view
        // feature on and selection available.
        if (
            isFeatureEnabled('notes-folder-view') &&
            this.tableView.tableQuery.folderId == folderNameToId('notes') &&
            notesStore.selectedNoteId
        ) {
            itemsToDisplay.push(this.deleteNoteMenuItem);
            itemsToDisplay.push(this.changeNoteColorMenuItem);
        }

        return itemsToDisplay;
    }

    @computed
    private get newMessageItem(): FilterableMenuItem {
        const onClick = () => {
            const groupId = !isFeatureEnabled('grp-groupHeaderV2') ? this.groupId : null;

            checkAndCreateNewMessage('CommandBar', groupId);
        };
        const renderFluentHeroButton = isFeatureEnabled('fwk-fluentCommandBar')
            ? () => {
                  return (
                      <NewMessageButton
                          scenario={'default'}
                          onClick={onClick}
                          onMouseOver={() => lazyOpenCompose.import()}
                      />
                  );
              }
            : null;
        return new FilterableMenuItem(
            loc(newMailAction),
            isFeatureEnabled('fwk-fluentCommandBar') ? null : ControlIcons.Add,
            onClick,
            this.shouldShowBehaviorMap[MenuItemType.NewMessage],
            null,
            getMailMenuItemShouldDisable(MenuItemType.NewMessage),
            null,
            null,
            renderFluentHeroButton
        );
    }

    @computed
    private get newNoteItem(): FilterableMenuItem {
        const renderFluentHeroButton = isFeatureEnabled('fwk-fluentCommandBar')
            ? () => {
                  return (
                      <NewMessageButton
                          scenario={'notes'}
                          onClick={this.onNewNoteButtonClicked}
                          onMouseOver={() => lazyCreateNewNote.import()}
                      />
                  );
              }
            : null;

        return new FilterableMenuItem(
            loc(newNoteAction),
            ControlIcons.Add,
            this.onNewNoteButtonClicked,
            this.shouldShowBehaviorMap[MenuItemType.NewNote],
            null,
            getMailMenuItemShouldDisable(MenuItemType.NewNote),
            null,
            null,
            renderFluentHeroButton
        );
    }

    private onNewNoteButtonClicked() {
        lazyCreateNewNote.importAndExecute();
    }

    @computed
    private get groupId(): string {
        return getGroupId(this.tableView);
    }

    @computed
    private get categoryMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(categoryMenuItemMenuText),
            ControlIcons.Tag,
            () => {},
            this.shouldShowBehaviorMap[MenuItemType.Categories],
            DisplayOption.Left,
            false, // disabled
            getCategoryMenuPropertiesForCommandBar(this.tableView, 'CommandBar') /*menuContent*/
        );
    }

    private get changeNoteColorMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            '',
            ControlIcons.Color,
            () => {},
            undefined, // shouldShow
            DisplayOption.Left,
            false, // disabled
            [],
            'changeNoteColor', // key
            () => {
                return (
                    <NoteColorButton
                        styles={
                            isFeatureEnabled('fwk-fluentCommandBar')
                                ? this.fluentReplyButtonStyles
                                : this.replyButtonStyles
                        }
                    />
                );
            }
        );
    }

    private replyButtonStyles = {
        splitButtonMenuIcon: styles.replyButtonContent,
        splitButtonContainer: styles.replyButtonContainer,
        splitButtonMenuButton: styles.replyButton,
        root: styles.replyButton,
        label: styles.replyButtonContent,
        icon: styles.replyButtonContent,
    };

    private fluentReplyButtonStyles = {
        splitButtonMenuIcon: styles.replyButtonContent,
        splitButtonContainer: styles.replyButtonContainerFluent,
        splitButtonMenuButton: styles.replyButtonMenuButtonFluent,
        root: styles.replyButtonRootFluent,
        label: styles.replyButtonContent,
        icon: styles.replyButtonContent,
    };

    @computed
    private get replyMenuItem() {
        const isReplyAll = isReplyAllTheDefaultResponse();
        return new FilterableMenuItem(
            '',
            isReplyAll ? ControlIcons.ReplyAll : ControlIcons.Reply,
            () => {},
            isReplyAll
                ? this.shouldShowBehaviorMap[MenuItemType.ReplyReplyAllForwardCommandBar]
                : this.shouldShowBehaviorMap[MenuItemType.Reply],
            null /* display option */,
            false /* disable */,
            [],
            isReplyAll ? 'replyAllMain' : 'replyMain' /* key */,
            () => {
                return (
                    <CommandBarButton
                        iconProps={isReplyAll ? { iconName: 'ReplyAll' } : { iconName: 'Reply' }}
                        data-automation-id={isReplyAll ? 'replyAll' : 'reply'}
                        disabled={false}
                        text={isReplyAll ? loc(itemHeaderReplyAll) : loc(itemHeaderReply)}
                        onClick={() => this.onReplyAllRow(isReplyAll /* isReplyAll */)}
                        split={true}
                        styles={
                            isFeatureEnabled('fwk-fluentCommandBar')
                                ? this.fluentReplyButtonStyles
                                : this.replyButtonStyles
                        }
                        menuProps={{
                            items: [
                                {
                                    key: 'reply',
                                    name: loc(itemHeaderReply),
                                    onClick: () => this.onReplyAllRow(false /* isReplyAll */),
                                },
                                {
                                    key: 'replyall',
                                    name: loc(itemHeaderReplyAll),
                                    onClick: () => this.onReplyAllRow(true /* isReplyAll */),
                                },
                                {
                                    key: 'forward',
                                    name: loc(itemHeaderForward),
                                    onClick: this.onForwardRow,
                                },
                            ],
                        }}
                    />
                );
            } /* onRender */
        );
    }

    @computed
    private get deleteMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            this.getDeleteMenuItemString(),
            ControlIcons.Delete,
            this.onDeleteClicked,
            this.shouldShowBehaviorMap[MenuItemType.Delete],
            null /* display option */,
            getMailMenuItemShouldDisable(MenuItemType.Delete)
        );
    }

    private getDeleteMenuItemString(): string {
        return getIsEverythingSelectedInTable(this.tableView)
            ? getEmptyFolderText(this.tableView)
            : loc(deleteItem);
    }

    @computed
    private get deleteNoteMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            this.getDeleteMenuItemString(),
            ControlIcons.Delete,
            this.onDeleteNoteClicked
        );
    }

    @computed
    private get restoreMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(restoreItem),
            MailIcons.RevToggleKey,
            this.onRestoreClicked,
            this.shouldShowBehaviorMap[MenuItemType.Restore]
        );
    }

    @computed
    private get archiveDraftMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(archive),
            ControlIcons.Archive,
            this.onArchiveClicked,
            this.shouldShowBehaviorMap[MenuItemType.Archive]
        );
    }

    @computed
    private get junkMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(junk),
            ControlIcons.Blocked,
            () => {} /* onClick */,
            this.shouldShowBehaviorMap[MenuItemType.MarkAsJunk],
            DisplayOption.Left,
            false /* disabled */,
            [
                new FilterableMenuItem(loc(junk), null /* icon */, this.onJunkNotJunkClicked),
                new FilterableMenuItem(loc(phishing), null /* icon */, this.onPhishingClicked),
                new FilterableMenuItem(
                    loc(block),
                    null /* icon */,
                    this.onBlockClicked,
                    this.shouldShowBehaviorMap[MenuItemType.Block]
                ),
            ]
        );
    }

    @computed
    private get notJunkMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(notjunk),
            null /* icon */,
            () => {} /* onClick */,
            this.shouldShowBehaviorMap[MenuItemType.MarkAsNotJunk],
            DisplayOption.Left,
            false /* disabled*/,
            [
                new FilterableMenuItem(loc(notjunk), null /* icon */, this.onJunkNotJunkClicked),
                new FilterableMenuItem(loc(phishing), null /* icon */, this.onPhishingClicked),
                new FilterableMenuItem(
                    loc(block),
                    null /* icon */,
                    this.onBlockClicked,
                    this.shouldShowBehaviorMap[MenuItemType.Block]
                ),
            ]
        );
    }

    @computed
    private get translateMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(itemHeaderTranslate),
            null /* icon */,
            this.onTranslateClicked,
            this.shouldShowBehaviorMap[MenuItemType.Translate],
            DisplayOption.Overflow
        );
    }

    @computed
    private get sweepMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(sweep),
            MailIcons.Broom,
            this.onSweepClicked,
            this.shouldShowBehaviorMap[MenuItemType.Sweep],
            DisplayOption.Left,
            isFolderPaused(this.tableView.tableQuery.folderId) // disabled
        );
    }

    @computed
    private get moveToMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(moveTo),
            MailIcons.FabricMovetoFolder,
            () => {},
            this.shouldShowBehaviorMap[MenuItemType.Move],
            DisplayOption.Left,
            false, // disabled
            getMoveToPropertiesForCommandBar(this.tableView, this.shouldShowBehaviorMap)
        );
    }

    @computed
    private get emptyFolderMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            getEmptyFolderText(this.tableView),
            ControlIcons.Delete,
            this.onDeleteAllClicked,
            this.shouldShowBehaviorMap[MenuItemType.EmptyFolder],
            DisplayOption.Left,
            isBulkActionInState(this.tableView.serverFolderId, BulkActionStateEnum.Running)
        );
    }

    @computed
    private get markAllAsReadMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(markAllAsRead),
            MailIcons.Read,
            this.onMarkAllAsReadClicked,
            this.shouldShowBehaviorMap[MenuItemType.MarkAllAsRead],
            DisplayOption.Left,
            isBulkActionInState(this.tableView.serverFolderId, BulkActionStateEnum.Running)
        );
    }

    @computed
    private get markAsUnreadMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(markAsUnread),
            this.groupId ? ControlIcons.Mail : null /* icon */,
            this.onMarkAsUnreadClicked,
            this.shouldShowBehaviorMap[MenuItemType.MarkAsUnread],
            this.groupId ? DisplayOption.Left : DisplayOption.Overflow,
            isBulkActionInState(this.tableView.serverFolderId, BulkActionStateEnum.Running)
        );
    }

    @computed
    private get markAsReadMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(markAsRead),
            this.groupId ? MailIcons.Read : null /* icon */,
            this.onMarkAsReadClicked,
            this.shouldShowBehaviorMap[MenuItemType.MarkAsRead],
            this.groupId ? DisplayOption.Left : DisplayOption.Overflow,
            isBulkActionInState(this.tableView.serverFolderId, BulkActionStateEnum.Running)
        );
    }

    @computed
    private get scheduleMenuItem(): FilterableMenuItem {
        const scheduleSubMenuDates = getSnoozeDateOptions();
        return new FilterableMenuItem(
            loc(snooze),
            ControlIcons.Clock,
            () => {},
            this.shouldShowBehaviorMap[MenuItemType.Schedule],
            DisplayOption.Left,
            false /* disabled */,
            createSnoozeSubMenu(
                this.onScheduleItemClicked,
                scheduleSubMenuDates,
                DirectionalHint.bottomLeftEdge
            )
        );
    }

    private onScheduleItemClicked = async (date?: OwaDate) => {
        const mailListViewStore = getStore();
        const tableView = mailListViewStore?.tableViews.get(this.props.tableViewId);
        if (tableView) {
            const rowKeys = [...tableView.selectedRowKeys.keys()];
            const scheduleRows = await lazyScheduleRows.import();
            scheduleRows(rowKeys, tableView.id, 'CommandBar' /* actionSource */, date);
        }
    };

    @computed
    private get flagMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(flag),
            null, // no icon
            this.onFlagUnflagClicked,
            this.shouldShowBehaviorMap[MenuItemType.Flag],
            DisplayOption.Overflow
        );
    }

    @computed
    private get unflagMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(unflag),
            null /* icon */,
            this.onFlagUnflagClicked,
            this.shouldShowBehaviorMap[MenuItemType.Unflag],
            DisplayOption.Overflow
        );
    }

    @computed
    private get pinMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(pin),
            null /* icon */,
            this.onPinUnpinClicked,
            this.shouldShowBehaviorMap[MenuItemType.Pin],
            DisplayOption.Overflow
        );
    }

    @computed
    private get unpinMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(unpin),
            null /* icon */,
            this.onPinUnpinClicked,
            this.shouldShowBehaviorMap[MenuItemType.Unpin],
            DisplayOption.Overflow
        );
    }

    @computed
    private get ignoreMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(ignore),
            null /* icon */,
            this.onIgnoreStopIgnoringClicked,
            this.shouldShowBehaviorMap[MenuItemType.Ignore],
            DisplayOption.Overflow
        );
    }

    @computed
    private get stopIgnoringMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(stopIgnoring),
            null /* icon */,
            this.onIgnoreStopIgnoringClicked,
            this.shouldShowBehaviorMap[MenuItemType.StopIgnoring],
            DisplayOption.Overflow
        );
    }

    @computed
    private get overflowDivider(): FilterableMenuItem {
        return new FilterableMenuItem(
            '-',
            '-',
            null,
            this.shouldShowBehaviorMap[MenuItemType.OverflowDivider],
            DisplayOption.Overflow
        );
    }

    @computed
    private get createRuleMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(createRule),
            null /* icon */,
            this.onCreateRuleClicked,
            this.shouldShowBehaviorMap[MenuItemType.InboxRule],
            DisplayOption.Overflow
        );
    }

    @computed
    private get printMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(print),
            null /* icon */,
            this.onPrintClicked,
            this.shouldShowBehaviorMap[MenuItemType.Print],
            DisplayOption.Overflow
        );
    }

    @computed
    private get showInImmersiveReaderMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(showInImmersiveReader_1),
            null /* icon */,
            this.onShowInImmersiveReaderClicked,
            this.shouldShowBehaviorMap[MenuItemType.ShowInImmersiveReader],
            DisplayOption.Overflow
        );
    }

    @computed
    private get assignPolicyMenuItem(): FilterableMenuItem {
        const item = new FilterableMenuItem(
            loc(assignPolicyMenuItemName),
            ' ', // empty icon to trigger onRenderIcon
            () => {},
            this.shouldShowBehaviorMap[MenuItemType.AssignPolicy],
            DisplayOption.Overflow,
            false /* disabled */,
            {
                items: [{ key: 'assignPolicySubMenu' }],
            } /*menuContent*/,
            null /*key*/,
            null /*onRender*/,
            false /*checked*/,
            null /*ariaLabel*/,
            null /*title*/,
            null /*classNames*/,
            false /*canCheck*/,
            false /*iconOnly*/,
            () => {
                // delay getting subMenuProps until onRenderIcon callback
                item.subMenuProps = getAssignPolicyPropertiesForMailContextMenu(
                    this.props.tableViewId,
                    'CommandBar' /* actionSource */
                );

                // render default style to align with rest of the menu items
                const styles = getClassNames(getMenuItemStyles, getTheme());
                return <Icon className={classNames('ms-ContextualMenu-icon', styles.icon)} />;
            } /*onRenderIcon*/
        );

        return item;
    }

    @computed
    private get undoMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(undoCommandingBar) /* name */,
            ControlIcons.Undo,
            this.onUndoClicked,
            this.shouldShowBehaviorMap[
                MenuItemType.Undo
            ] /* Hide in search mode and immersive RP */,
            DisplayOption.Left,
            !undoActions.hasUndoableAction()
        );
    }

    @computed
    private get optOutMenuItem(): FilterableMenuItem {
        return new FilterableMenuItem(
            loc(optOutToggleLabel),
            null,
            createOptOutToggleHandler(),
            this.shouldShowBehaviorMap[MenuItemType.ClientOptOut],
            DisplayOption.Right,
            false,
            null,
            null,
            item => <OptOutToggle item={item} />
        );
    }

    /**
     * We are adding this item so that commanding bar left and right items do not overlap
     * This is currently happening because of the fluent button styles which are adding
     * custom margins\border etc which are not accounted for in command bar measurement
     * calculations. 48px seems to work fine with and helps in pushing enough items in overflow
     * so that left items do not overlap with right.
     */
    private get pseudoItemForCorrection(): FilterableMenuItem {
        return new FilterableMenuItem(
            null,
            null,
            null,
            () => true,
            DisplayOption.Right,
            false,
            null,
            null,
            () => {
                return <div style={{ width: '48px' }} />;
            }
        );
    }

    @computed
    private get upNextMenuItem(): FilterableMenuItem {
        const upNextButtonStyles = {
            root: styles.upNextButtonRoot,
        };

        return new FilterableMenuItem(
            null,
            null,
            null,
            this.shouldShowBehaviorMap[MenuItemType.UpNext],
            DisplayOption.Right,
            false,
            null,
            null,
            () => {
                return <UpNextV2 containerStyle={upNextButtonStyles} />;
            },
            false,
            null,
            null,
            null,
            false,
            false,
            null,
            null,
            this.cacheKeyForUpNextItem
        );
    }

    @computed
    private get isSelectPreviousMenuItemDisabled(): boolean {
        const tableView = this.tableView;
        const selectedRowKeys = [...tableView.selectedRowKeys.keys()];
        return tableView.selectedRowKeys.size == 1 && tableView.rowKeys[0] == selectedRowKeys[0];
    }

    @computed
    private get selectPreviousMenuItem(): FilterableMenuItem {
        const name = loc(previousLabel);
        return new FilterableMenuItem(
            null /* name */,
            ControlIcons.Up,
            this.onUpClicked,
            this.shouldShowBehaviorMap[MenuItemType.SelectionNavigation],
            DisplayOption.Right,
            this.isSelectPreviousMenuItemDisabled,
            null /*menuContent*/,
            'previous',
            null /*onRender*/,
            false /*checked*/,
            name,
            name
        ); // disabled for the first item of the table
    }

    @computed
    private get isSelectNextMenuItemDisabled(): boolean {
        const tableView = this.tableView;
        const selectedRowKeys = [...tableView.selectedRowKeys.keys()];
        return (
            tableView.selectedRowKeys.size == 1 &&
            tableView.rowKeys[tableView.rowKeys.length - 1] == selectedRowKeys[0]
        );
    }

    @computed
    private get selectNextMenuItem(): FilterableMenuItem {
        const name = loc(nextLabel);
        return new FilterableMenuItem(
            null /* name */,
            ControlIcons.Down,
            this.onDownClicked,
            this.shouldShowBehaviorMap[MenuItemType.SelectionNavigation],
            DisplayOption.Right,
            this.isSelectNextMenuItemDisabled,
            null /*menuContent*/,
            'next',
            null /*onRender*/,
            false /*checked*/,
            name,
            name
        ); // disabled for the last item of the table
    }

    @computed
    private get closeImmersiveReadingPaneMenuItem(): FilterableMenuItem {
        const name = loc(closeLabel);
        return new FilterableMenuItem(
            null /* name */,
            ControlIcons.Cancel,
            () => closeImmersiveReadingPane('ImmersiveRPCloseButton'),
            this.shouldShowBehaviorMap[MenuItemType.SelectionNavigation],
            DisplayOption.Right,
            false /*isDisabled*/,
            null /*menuContent*/,
            'close',
            null /*onRender*/,
            false /*checked*/,
            name,
            name
        );
    }

    private onReplyAllRow = (isReplyAll: boolean) => {
        const tableView = this.tableView;
        const rowKey = [...tableView.selectedRowKeys.keys()][0];
        const rowId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView);
        const suppressServerMarkReadOnReplyOrForward = shouldSuppressServerMarkReadOnReplyOrForward(
            tableView
        );
        let instrumentationContexts;
        if (tableView.tableQuery.type == TableQueryType.Search) {
            instrumentationContexts = getInstrumentationContextsFromTableView([rowKey], tableView);
        }
        switch (tableView.tableQuery.listViewType) {
            case ReactListViewType.Conversation:
                lazyReplyToConversation.importAndExecute(
                    rowId,
                    isReplyAll,
                    'CommandBar',
                    instrumentationContexts,
                    isReadingPanePositionBottom() /*useFullCompose*/,
                    suppressServerMarkReadOnReplyOrForward
                );
                break;

            case ReactListViewType.Message:
                lazyReplyToItem.importAndExecute(
                    rowId,
                    isReplyAll,
                    instrumentationContexts,
                    'CommandBar',
                    suppressServerMarkReadOnReplyOrForward
                );
        }
    };

    private onForwardRow = () => {
        const tableView = this.tableView;
        const rowKey = [...tableView.selectedRowKeys.keys()][0];
        const rowId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView);
        const suppressServerMarkReadOnReplyOrForward = shouldSuppressServerMarkReadOnReplyOrForward(
            tableView
        );
        let instrumentationContexts;

        if (tableView.tableQuery.type == TableQueryType.Search) {
            instrumentationContexts = getInstrumentationContextsFromTableView([rowKey], tableView);
        }
        switch (tableView.tableQuery.listViewType) {
            case ReactListViewType.Conversation:
                lazyForwardConversation.importAndExecute(
                    rowId,
                    'CommandBar',
                    instrumentationContexts,
                    suppressServerMarkReadOnReplyOrForward
                );
                break;
            case ReactListViewType.Message:
                lazyForwardItem.importAndExecute(
                    rowId,
                    'CommandBar',
                    instrumentationContexts,
                    suppressServerMarkReadOnReplyOrForward
                );
                break;
        }
    };

    private onDeleteClicked = async () => {
        // VSO 16732: Add confirm dialog for deleting items in select-all mode in search, and for deleting items in Deleted Items folder
        const tableView = this.tableView;
        if (tableView.isInVirtualSelectAllMode) {
            // When in virtual selection, i.e non search and select all mode,
            // delete all in the folder
            lazyTriageActions.lazyEmptyTableView.importAndExecute(
                tableView,
                false /*isExplicitSoftDelete*/,
                'CommandBar',
                tableView.virtualSelectAllExclusionList
            );
        } else if (this.isItemPartCommandBarOperation) {
            const deleteItemsBasedOnNodeIds = await lazyTriageActions.lazyDeleteItemsBasedOnNodeIds.import();
            deleteItemsBasedOnNodeIds(
                listViewStore.expandedConversationViewState.selectedNodeIds,
                tableView.id,
                'CommandBar'
            );
        } else {
            lazyTriageActions.lazyDeleteMailListRows.importAndExecute(
                [...tableView.selectedRowKeys.keys()],
                tableView.id,
                false /*isExplicitSoftDelete*/,
                'CommandBar'
            );
        }

        lazyResetFocus.importAndExecute();
    };

    private onDeleteNoteClicked() {
        lazyDeleteNote.importAndExecute();
    }

    private onArchiveClicked = async () => {
        const tableView = this.tableView;

        if (this.isItemPartCommandBarOperation) {
            const moveItemsBasedOnNodeIds = await lazyTriageActions.lazyMoveItemsBasedOnNodeIds.import();

            moveItemsBasedOnNodeIds(
                listViewStore.expandedConversationViewState.selectedNodeIds,
                folderNameToId('archive'),
                tableView.id,
                'CommandBar'
            );
        } else {
            lazyTriageActions.lazyArchiveMailListRows.importAndExecute(
                [...tableView.selectedRowKeys.keys()],
                tableView,
                'CommandBar'
            );
        }
        lazyResetFocus.importAndExecute();
    };

    private onRestoreClicked = () => {
        const tableView = this.tableView;
        lazyTriageActions.lazyRestoreMailListRowsAction.importAndExecute(
            [...tableView.selectedRowKeys.keys()],
            this.tableView.id
        );
        lazyResetFocus.importAndExecute();
    };

    private onJunkNotJunkClicked = async (ev?: any, item?: IContextualMenuItem) => {
        const tableView = this.tableView;
        const isJunkValueToSet = item.key == loc(junk);

        if (this.isItemPartCommandBarOperation) {
            const lazyMarkItemsJunkNotJunkBasedOnNodeIds = await lazyTriageActions.lazyMarkItemsJunkNotJunkBasedOnNodeIds.import();

            lazyMarkItemsJunkNotJunkBasedOnNodeIds(
                listViewStore.expandedConversationViewState.selectedNodeIds,
                tableView.id,
                isJunkValueToSet,
                'CommandBar'
            );
        } else {
            lazyTriageActions.lazyMarkRowsJunkNotJunk.importAndExecute(
                [...tableView.selectedRowKeys.keys()],
                tableView,
                isJunkValueToSet,
                'CommandBar' /* actionSource */
            );
        }
        lazyResetFocus.importAndExecute();
    };

    private onPhishingClicked = () => {
        const tableView = this.tableView;
        lazyTriageActions.lazyMarkRowsAsPhishingFromTable.importAndExecute(
            [...tableView.selectedRowKeys.keys()],
            tableView,
            'CommandBar'
        );
        lazyResetFocus.importAndExecute();
    };

    private onDeleteAllClicked = () => {
        const tableView = this.tableView;
        if (tableView.tableQuery.type == TableQueryType.Search) {
            // currently we do not support EmptyFolder in search view
            lazyTriageActions.lazyEmptySearchTableView.importAndExecute(tableView);
        } else {
            lazyTriageActions.lazyEmptyTableView.importAndExecute(
                tableView,
                false /*isExplicitSoftDelete*/,
                'CommandBar',
                [] /*rowKeysToExclude*/
            );
        }
    };

    private onMarkAsReadClicked = () => {
        this.onMarkAsReadUnreadInternal(true /* isReadValueSet */);
    };

    private onMarkAsUnreadClicked = () => {
        this.onMarkAsReadUnreadInternal(false /* isReadValueSet */);
    };

    private onMarkAsReadUnreadInternal = async (isReadValueSet: boolean) => {
        const tableView = this.tableView;
        const isInVirtualSelectAllMode = tableView.isInVirtualSelectAllMode;
        const rowKeysToActOn = isInVirtualSelectAllMode
            ? []
            : [...tableView.selectedRowKeys.keys()];
        const exclusionList = isInVirtualSelectAllMode
            ? tableView.virtualSelectAllExclusionList
            : [];

        if (this.isItemPartCommandBarOperation) {
            const markItemsAsReadBasedOnNodeIds = await lazyMarkItemsAsReadBasedOnNodeIds.import();
            markItemsAsReadBasedOnNodeIds(
                listViewStore.expandedConversationViewState.selectedNodeIds,
                tableView.id,
                isReadValueSet,
                true /* isExplicit */,
                'CommandBar'
            );
        } else {
            lazyMarkAsReadInTable.importAndExecute(
                'CommandBar',
                exclusionList,
                isInVirtualSelectAllMode /* isActingOnAllItemsInTable */,
                isReadValueSet,
                rowKeysToActOn,
                tableView
            );
        }
        lazyResetFocus.importAndExecute();
    };

    private onBlockClicked = () => {
        const tableView = this.tableView;
        lazyTriageActions.lazyBlockLastSendersFromTable.importAndExecute(
            [...tableView.selectedRowKeys.keys()],
            tableView,
            'CommandBar'
        );

        lazyResetFocus.importAndExecute();
    };

    private onSweepClicked = () => {
        const tableView = this.tableView;
        lazyShowSweepDialog.importAndExecute([...tableView.selectedRowKeys.keys()], tableView);
        lazyResetFocus.importAndExecute();
    };

    private onFlagUnflagClicked = async (ev?: any, item?: IContextualMenuItem) => {
        const tableView = this.tableView;
        const flagStatus = item.key == loc(flag) ? 'Flagged' : 'NotFlagged';

        if (this.isItemPartCommandBarOperation) {
            const setItemsFlagStateBasedOnNodeIds = await lazyTriageActions.lazySetItemsFlagStateBasedOnNodeIds.import();
            setItemsFlagStateBasedOnNodeIds(
                listViewStore.expandedConversationViewState.selectedNodeIds,
                tableView.id,
                flagStatus,
                'CommandBar'
            );
        } else {
            lazyTriageActions.lazySetMailListRowsFlagState.importAndExecute(
                [...tableView.selectedRowKeys.keys()],
                tableView.id,
                { FlagStatus: flagStatus },
                'CommandBar'
            );
        }
        lazyResetFocus.importAndExecute();
    };

    private onPinUnpinClicked = (ev?: any, item?: IContextualMenuItem) => {
        const tableView = this.tableView;
        lazyTriageActions.lazyMarkRowsPinnedUnpinned.importAndExecute(
            [...tableView.selectedRowKeys.keys()],
            tableView.id,
            item.key == loc(pin) /* shouldMarkAsPinned */,
            'CommandBar'
        );

        lazyResetFocus.importAndExecute();
    };

    private onIgnoreStopIgnoringClicked = async (ev?: any, item?: IContextualMenuItem) => {
        const tableView = this.tableView;
        const toggleIgnoreConversations = await lazyTriageActions.lazyToggleIgnoreConversations.import();
        toggleIgnoreConversations(
            [...tableView.selectedRowKeys.keys()],
            tableView.id,
            item.key == loc(ignore) /*shouldIgnore*/,
            'CommandBar'
        );
        lazyResetFocus.importAndExecute();
    };

    private onShowInImmersiveReaderClicked = () => {
        const rowKey = [...this.tableView.selectedRowKeys.keys()][0];
        const selectedRowId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, this.tableView);
        switch (this.tableView.tableQuery.listViewType) {
            case ReactListViewType.Conversation:
                lazyShowConversationInImmersiveReader.importAndExecute(
                    selectedRowId /* conversationId */,
                    'CommandBar'
                );
                break;

            case ReactListViewType.Message:
                showInImmersiveReader(selectedRowId /* itemId */, 'CommandBar');
                break;
        }
    };

    private onUndoClicked() {
        undoActions.lazyUndo.importAndExecute('CommandBar');
        lazyResetFocus.importAndExecute();
    }

    private onUpClicked = () => {
        const tableView = this.tableView;
        const selectedRowkeys = [...tableView.selectedRowKeys.keys()];

        if (!selectedRowkeys[0]) {
            throw new Error('undefined row key ' + selectedRowkeys);
        }

        lazyOnNavigateAwayViaUpDown.importAndExecute(selectedRowkeys[0], tableView);
        selectRowInDirection(
            tableView,
            SelectionDirection.Previous,
            MailListItemSelectionSource.CommandBarArrows
        );
    };

    private onDownClicked = () => {
        const tableView = this.tableView;
        const selectedRowkeys = [...tableView.selectedRowKeys.keys()];

        if (!selectedRowkeys[0]) {
            throw new Error('undefined row key ' + selectedRowkeys);
        }

        lazyOnNavigateAwayViaUpDown.importAndExecute(selectedRowkeys[0], tableView);
        selectRowInDirection(
            tableView,
            SelectionDirection.Next,
            MailListItemSelectionSource.CommandBarArrows
        );
    };

    private onMarkAllAsReadClicked = () => {
        const tableView = this.tableView;

        let isInVirtualSelectAllMode: boolean;
        let exclusionList: string[];
        let rowKeysToActOn: string[];

        /**
         * "Mark all as read" commands can generally be treated as virtual
         * select all. However, in the case of seach results, it needs to be
         * special-cased to use all item IDs since there's no backing folder
         * for the markAllAsReadService to use.
         */
        if (tableView.tableQuery.type === TableQueryType.Search) {
            isInVirtualSelectAllMode = false;
            exclusionList = [];
            rowKeysToActOn = tableView.rowKeys;
        } else {
            isInVirtualSelectAllMode = true;
            exclusionList = tableView.virtualSelectAllExclusionList;
            rowKeysToActOn = [];
        }

        lazyMarkAsReadInTable.importAndExecute(
            'CommandBar',
            exclusionList,
            isInVirtualSelectAllMode /* isActingOnAllItemsInTable */,
            true /* isReadValueToSet */,
            rowKeysToActOn,
            tableView,
            true /* isMarkAllAsRead */
        );

        lazyResetFocus.importAndExecute();
    };

    /**
     * Called when user clicks on the create rule menu item
     */
    private onCreateRuleClicked = async () => {
        const tableView = this.tableView;
        const rowKey = [...tableView.selectedRowKeys.keys()][0];
        const createRuleFromRow = await lazyCreateRuleFromRow.import();
        createRuleFromRow(rowKey, tableView.id, 'CommandBar');
    };

    private onPrintClicked = () => {
        const rowKey = [...this.tableView.selectedRowKeys.keys()][0];
        const selectedRowId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, this.tableView);
        switch (this.tableView.tableQuery.listViewType) {
            case ReactListViewType.Conversation:
                lazyPrintConversation.importAndExecute(
                    selectedRowId /* conversationId */,
                    'CommandBar'
                );
                break;

            case ReactListViewType.Message:
                lazyPrintItem.importAndExecute(selectedRowId /* itemId */, 'CommandBar');
                break;
        }

        lazyResetFocus.importAndExecute();
    };

    private onTranslateClicked = () => {
        lazyTriageActions.lazyTranslateFromTable.importAndExecute(
            [...this.tableView.selectedRowKeys.keys()],
            this.tableView,
            'CommandBar'
        );
        lazyResetFocus.importAndExecute();
    };
}
